import React from 'react';

import { Skeleton } from '~/components/utils';

import { Container, ValueContent } from '../styles';

interface ItemDetailSkeletonProps {
  showIcon?: boolean;
}

export const ItemDetailSkeleton: React.FC<ItemDetailSkeletonProps> = ({
  showIcon,
}) => (
  <Container>
    <Skeleton variant="text" height={20} width={70} />
    <ValueContent>
      {showIcon && <Skeleton variant="circle" height={16} width={16} />}
      <Skeleton variant="text" height={24} width={100} />
    </ValueContent>
  </Container>
);

export default ItemDetailSkeleton;
